import React, { HTMLAttributes, useCallback, useEffect, useState } from 'react';

import ButtonComponent from '../../../Button';
import Close from '../../../ButtonCancel';
import FillPhone from '../FillPhone';
import validateCnpj from '../../../../services/utils/validateCnpj';
import validateCpf from '../../../../services/utils/validateCpf';
import format from '../../../../services/utils/formatCPFandCNPJ';

import { Content, CpfContainer } from './styles';
import { AiOutlineCheck } from 'react-icons/ai';
import { useSelector } from 'react-redux';
interface IDetails {
  title: string;
  subtitle: string;
  detail: string;
  datehour: string;
}
interface Props extends HTMLAttributes<HTMLElement> {
  changeTitle: () => void;
  handlerClose: () => void;
  title: string;
  subtitle: string;
  textbtn: string;
  text2btn: string;
  type: 'ReceberLigacao' | '';
  details: IDetails;
  verification: string;
}

const FillCPF: React.FC<Props> = (props) => {
  const [validCpf, setValidCpf] = useState(false);
  const [filledCpf, setFilledCpf] = useState(false);

  const { value, signed } = useSelector((state: ApplicationState) => {
    return {
      value: state.auth.cpf,
      signed: state.auth.signed,
    };
  });

  const [nextPage, setNextPage] = useState(
    value.length > 0 && signed ? true : false
  );

  const handleCpfValue = (e: React.ChangeEvent<HTMLInputElement>) => {
    setCpf(e.target.value.replace(/[^0-9]/g, '').replace(/(\..*)\./g, '$1'));
  };

  const [cpf, setCpf] = useState(value);

  const validaCpfCnpj = useCallback((val: string) => {
    if (!val) return;

    const numericValue = val.replace(/\D/g, '');

    if (numericValue.length >= 6 && numericValue.length <= 11) {
      setFilledCpf(true);
      setValidCpf(validateCpf(numericValue.padStart(11, '0')));
    }

    if (numericValue.length === 14) {
      setFilledCpf(true);
      setValidCpf(validateCnpj(numericValue));
    }

    if (
      !(numericValue.length >= 6 && numericValue.length <= 11) &&
      numericValue.length !== 14
    ) {
      setFilledCpf(false);
      setValidCpf(false);
    }
  }, []);

  useEffect(() => {
    validaCpfCnpj(cpf);
  }, [cpf, validaCpfCnpj]);
  const nextStep = () => {
    setNextPage(!nextPage);
  };

  return (
    <>
      {!nextPage ? (
        <div>
          <Content>
            <div className='title_receivecall'>
              <span>{props.title}</span>
              <div className='subtitle_receivecall'>
                <span>{props.subtitle}</span>
                <div className='default'>
                  <CpfContainer valid={validCpf} filled={filledCpf}>
                    <input
                      type='text'
                      placeholder='Digite seu CPF'
                      value={format(cpf)}
                      onChange={handleCpfValue}
                      maxLength={18}
                    />
                    <div className='invalidCPF'>
                      {cpf && cpf?.length > 11 ? 'CNPJ' : 'CPF'} inválido
                    </div>
                    <span>
                      <AiOutlineCheck />
                    </span>
                  </CpfContainer>
                </div>
              </div>
              <div className='btns_receivecall'>
                <ButtonComponent
                  height={60}
                  onClick={nextStep}
                  children={<p>PRÓXIMO</p>}
                  color={'primary'}
                  fontSize={'16'}
                  borderRadios={'16'}
                  disabled={!validCpf}
                />
                <Close onClick={props.handlerClose}>CANCELAR</Close>
              </div>
            </div>
          </Content>
        </div>
      ) : (
        <FillPhone
          changeTitle={props.changeTitle}
          value={format(cpf)}
          onClick={nextStep}
          handlerClose={props.handlerClose}
          textbtn={props.textbtn}
          text2btn={props.text2btn}
          type={props.type}
          details={props.details}
          sign={signed}
          verification={props.verification}
        />
      )}
    </>
  );
};

export default FillCPF;
